/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/pure-multiple-choice-exercise/v1.ts
 */

import { createValidator } from '../../helpers/validator';
export const PureMultipleChoiceExerciseV1Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    },
    question: {
      type: 'object',
      properties: {
        flavor: {
          type: 'string',
          enum: ['PureMultipleChoice'],
          default: 'PureMultipleChoice'
        },
        feedback: {
          type: 'array',
          items: {
            type: 'string'
          }
        },
        possible_answers: {
          type: 'array',
          items: {
            type: 'string'
          }
        }
      },
      required: ['flavor', 'feedback', 'possible_answers']
    }
  },
  required: ['assignment', 'chapter_id', 'course_id', 'hint', 'question', 'title', 'xp'],
  definitions: {}
};
export const isValidPureMultipleChoiceExerciseV1 = createValidator(PureMultipleChoiceExerciseV1Schema);
export const PureMultipleChoiceExerciseV1Definition = {
  schema: PureMultipleChoiceExerciseV1Schema,
  validate: isValidPureMultipleChoiceExerciseV1
};